import Drawer from "components/DrawerV2";
import XICon from "components/icons/XICon";
import { useMemo } from "react";
import { useAuth, useUI } from "state";
import { useEnvs } from "state/EnvironmentsContext/EnvContext";
import { encrypt } from "utils/encrypt";

const DOC_EXTRACTOR_BASE_URL = "https://dev-docextractor.blink.global/";

const AiChat = ({ eventID }: { eventID?: number | string }) => {
  const FoundationURL = useEnvs((state) => state.FoundationURL);
  const { user } = useAuth();
  const { closeRightDrawer } = useUI();

  const iframeSrc = useMemo(() => {
    const payload = {
      org_base_url: window.location.origin + "/",
      foundation_base_url: FoundationURL ?? "",
      admin_token: localStorage.getItem("token") ?? "",
      event_id: eventID?.toString() ?? "",
      name: user?.name ?? "",
    };

    const encryptedToken = encrypt(JSON.stringify(payload));
    if (!encryptedToken) return DOC_EXTRACTOR_BASE_URL;

    const params = new URLSearchParams();
    params.set("token", encryptedToken);
    params.set("embedded", "1");

    return `${DOC_EXTRACTOR_BASE_URL}?${params.toString()}`;
  }, [FoundationURL, user, eventID]);

  return (
    <Drawer className="overflow-hidden md:!w-[400px]">
      <Drawer.Header className="!pl-6 !pr-4 !py-3 flex items-center justify-between gap-2 !relative">
        <h1 className="text-base font-bold text-white flex-shrink-0">
          AI Flight Assistant
        </h1>

        <button
          className="cursor-pointer p-3 rounded-[6px] flex items-center justify-center"
          onClick={closeRightDrawer}
        >
          <XICon className="h-6 w-6" fill="white" />
        </button>
      </Drawer.Header>

      <Drawer.Body className="flex-1 !min-h-[80vh] !p-0 !pb-1">
        <iframe
          src={iframeSrc}
          title="Doc Extractor"
          className="w-full h-screen border-0"
          allow="clipboard-read; clipboard-write"
          sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
        />
      </Drawer.Body>
    </Drawer>
  );
};

export default AiChat;
